import {createFileRoute} from '@tanstack/react-router';
import {CreditAccountPaymentListPage} from 'pages/accounts/credits/payment/CreditAccountPaymentListPage';

export const Route = createFileRoute('/_protected/credit-account-payment/')({
  component: CreditAccountPaymentListPage,
});
